import { endOfMonth, startOfMonth, subMonths } from 'date-fns';

type GetReportingTimeframeArgs = {
  today: Date;
};

export const getReportingTimeframe = ({ today }: GetReportingTimeframeArgs) => {
  // We display 4 months of reporting data in the UI, starting current month minus 3 and finishing in the current month
  // i.e. if today is April 27th, 2025, we display data from January 2025 to end of month April 2025
  const endReportingDate = endOfMonth(today);
  const startReportingDate = startOfMonth(subMonths(endReportingDate, 3));

  return { endReportingDate, startReportingDate };
};
